import router from '@/js/router/';
import { createApp } from 'vue'
import App from './app.vue'
import store from '@/js/store/'

import {loading, htmlReady} from '@/js/components/utils/common';
import Mixins from '@/js/components/mixins/';

import '@/scss/_index.scss';

class Entry {
	constructor() {
		loading('#knd-app');		
		store.dispatch("fetchContent").then(() => {
			this.renderApp('#knd-app', App);
		});		
	}

	renderApp(id, Comp) {
		let app = createApp({
			extends: Comp,
			mixins: [Mixins]
		});

		app.use(router);
		app.use(store);
		app.mount(id);
	}

}

htmlReady(() => {
	const start = new Entry();
})

